"use client";
import { useUiControlLabels } from "@/components/i18n/ui-control-labels-context"


import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getRESOLUTION_CONFIG } from "../constants";
import type { ResolutionQualityData, ResolutionCategory } from "../types";
import { useTranslations } from "next-intl"


interface ResolutionQualityCardsProps {
  data: ResolutionQualityData[];
}

export function ResolutionQualityCards({ data }: ResolutionQualityCardsProps) {
  const {locale: uiFormattingLocale} = useUiControlLabels()

  const tUi = useTranslations("Email.AgentsEmailAnalyticsSectionsResolutionQualityCards")
  const RESOLUTION_CONFIG = getRESOLUTION_CONFIG(useTranslations("Metadata.EmailAnalytics"))

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-medium"><span key={tUi("resolutionQuality")}>{tUi("resolutionQuality")}</span></CardTitle>
        <p className="text-xs text-muted-foreground">
          <span key={tUi("closedThreadsByLastCustomerSentimentBlacklistedForwarded")}>{tUi("closedThreadsByLastCustomerSentimentBlacklistedForwarded")}</span></p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
          {data.map((item) => {
            const cfg = RESOLUTION_CONFIG[item.category as ResolutionCategory];
            return (
              <div key={item.category} className={`rounded-lg p-3 text-center lg:p-5 ${cfg?.bg}`}>
                <div className={`text-xs font-semibold uppercase tracking-wide ${cfg?.text} mb-2`}>
                  {cfg?.title}
                </div>
                <div className={`text-3xl font-bold ${cfg?.text}`}>
                  {item.pct}<span>%</span>
                </div>
                <div className={`text-sm font-medium mt-1 ${cfg?.text}`}>
                  {item.count.toLocaleString(uiFormattingLocale)} <span><span key={tUi("threads")}>{tUi("threads")}</span></span>
                </div>
                <div className="text-xs text-muted-foreground mt-2">
                  {cfg?.description}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
